import React, { useState, useEffect, useRef } from 'react';
import './Shimmer.css'; // Style for shimmer effect

const oneLiners = [
    "Guru aapke jeevan mein samriddhi aur gyaan laa sakta hai.",
    "Shani agar pratikool ho, toh delays aur struggles badh jaate hain.",
    "Chandra ki shanti se man ki shanti milti hai.",
    "Budh aapki soch aur communication mein tez banata hai.",
    "Mangal ka prabhav ho toh energy aur aggression dono badhte hain.",
    "Rahu illusion aur confusion create karta hai – sab kuch sach nahi hota!",
    "Ketu spiritual banata hai, lekin detachment bhi laata hai.",
    "Lagna yaani ascendant, aapki personality ka base hota hai.",
    "Dusra ghar dhan aur vaani ka hota hai – yeh paisa aur baat dono dikhata hai.",
    "Saptam bhaav (7th house) se shaadi aur partnerships dekhi jaati hain.",
    "Ashtam bhaav life ke secrets aur transformations dikhata hai.",
    "Pancham ghar se aapka creativity aur love life judge hota hai.",
    "Dasam ghar career aur public image batata hai.",
    "Chhatha ghar rogon aur dushmanon ka hota hai.",
    "Guru Mangal ki yuti ho toh insaan bahut passionate aur spiritual ho sakta hai.",
    "Surya aapki leadership aur ego dikhata hai.",
    "Chandra-Mangal ki yuti emotional decision making ko strong banati hai.",
    "Venus agar strong ho, toh luxury aur romance dono zindagi mein aate hain.",
    "Mangal 1st house mein ho toh person bold aur energetic hota hai.",
    "Shani 7th house mein ho toh shaadi late ya tough ho sakti hai.",
    "Rahu 10th house mein ho toh log aapko career ke liye yaad rakhte hain.",
    "Chandra 4th house mein emotional connection family se hota hai.",
    "Ketu agar lagna mein ho, toh vyakti thoda alag aur spiritual ho sakta hai.",
    "Sun-Mercury ka Budh-Aditya yog intelligence ke liye best mana jaata hai.",
    "Venus-Mars ki yuti strong attraction aur passion laati hai.",
    "Rahu agar 2nd house mein ho, toh relationships mein complications create karta hai.",
    "Ketu agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
    "Surya agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Chandra agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Mangal agar 6th house mein ho, toh mental peace ko affect karta hai.",
    "Budh agar 7th house mein ho, toh insaan ko self-confident banata hai.",
    "Guru agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Shukra agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Shani agar 10th house mein ho, toh career mein growth ke chances deta hai.",
    "Rahu agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Ketu agar 12th house mein ho, toh relationships mein complications create karta hai.",
    "Surya agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
    "Chandra agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Mangal agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Budh agar 4th house mein ho, toh mental peace ko affect karta hai.",
    "Guru agar 5th house mein ho, toh insaan ko self-confident banata hai.",
    "Shukra agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Shani agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Rahu agar 8th house mein ho, toh career mein growth ke chances deta hai.",
    "Ketu agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Surya agar 10th house mein ho, toh relationships mein complications create karta hai.",
    "Chandra agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Mangal agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Budh agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Guru agar 2nd house mein ho, toh mental peace ko affect karta hai.",
    "Shukra agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
    "Shani agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Rahu agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Ketu agar 6th house mein ho, toh career mein growth ke chances deta hai.",
    "Surya agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Chandra agar 8th house mein ho, toh relationships mein complications create karta hai.",
    "Mangal agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Budh agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Guru agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Shukra agar 12th house mein ho, toh mental peace ko affect karta hai.",
    "Shani agar 1st house mein ho, toh insaan ko self-confident banata hai.",
    "Rahu agar 2nd house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Ketu agar 3rd house mein ho, toh vyakti mein creativity badhaata hai.",
    "Surya agar 4th house mein ho, toh career mein growth ke chances deta hai.",
    "Chandra agar 5th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Mangal agar 6th house mein ho, toh relationships mein complications create karta hai.",
    "Budh agar 7th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Guru agar 8th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Shukra agar 9th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Shani agar 10th house mein ho, toh mental peace ko affect karta hai.",
    "Rahu agar 11th house mein ho, toh insaan ko self-confident banata hai.",
    "Ketu agar 12th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Surya agar 1st house mein ho, toh vyakti mein creativity badhaata hai.",
    "Chandra agar 2nd house mein ho, toh career mein growth ke chances deta hai.",
    "Mangal agar 3rd house mein ho, toh emotional ups and downs laa sakta hai.",
    "Budh agar 4th house mein ho, toh relationships mein complications create karta hai.",
    "Guru agar 5th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Shukra agar 6th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Shani agar 7th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Rahu agar 8th house mein ho, toh mental peace ko affect karta hai.",
    "Ketu agar 9th house mein ho, toh insaan ko self-confident banata hai.",
    "Surya agar 10th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Chandra agar 11th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Mangal agar 12th house mein ho, toh career mein growth ke chances deta hai.",
    "Budh agar 1st house mein ho, toh emotional ups and downs laa sakta hai.",
    "Guru agar 2nd house mein ho, toh relationships mein complications create karta hai.",
    "Shukra agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
    "Shani agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Rahu agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Ketu agar 6th house mein ho, toh mental peace ko affect karta hai.",
    "Surya agar 7th house mein ho, toh insaan ko self-confident banata hai.",
    "Chandra agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Mangal agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Budh agar 10th house mein ho, toh career mein growth ke chances deta hai.",
    "Guru agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Shukra agar 12th house mein ho, toh relationships mein complications create karta hai.",
    "Shani agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
    "Rahu agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Ketu agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Surya agar 4th house mein ho, toh mental peace ko affect karta hai.",
    "Chandra agar 5th house mein ho, toh insaan ko self-confident banata hai.",
    "Mangal agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Budh agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Guru agar 8th house mein ho, toh career mein growth ke chances deta hai.",
    "Shukra agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Shani agar 10th house mein ho, toh relationships mein complications create karta hai.",
    "Rahu agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Ketu agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Surya agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Chandra agar 2nd house mein ho, toh mental peace ko affect karta hai.",
    "Mangal agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
    "Budh agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Guru agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Shukra agar 6th house mein ho, toh career mein growth ke chances deta hai.",
    "Shani agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Rahu agar 8th house mein ho, toh relationships mein complications create karta hai.",
    "Ketu agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Surya agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Chandra agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Mangal agar 12th house mein ho, toh mental peace ko affect karta hai.",
    "Budh agar 1st house mein ho, toh insaan ko self-confident banata hai.",
    "Guru agar 2nd house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Shukra agar 3rd house mein ho, toh vyakti mein creativity badhaata hai.",
    "Shani agar 4th house mein ho, toh career mein growth ke chances deta hai.",
    "Rahu agar 5th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Ketu agar 6th house mein ho, toh relationships mein complications create karta hai.",
    "Surya agar 7th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Chandra agar 8th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Mangal agar 9th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Budh agar 10th house mein ho, toh mental peace ko affect karta hai.",
    "Guru agar 11th house mein ho, toh insaan ko self-confident banata hai.",
    "Shukra agar 12th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Shani agar 1st house mein ho, toh vyakti mein creativity badhaata hai.",
    "Rahu agar 2nd house mein ho, toh career mein growth ke chances deta hai.",
    "Ketu agar 3rd house mein ho, toh emotional ups and downs laa sakta hai.",
    "Surya agar 4th house mein ho, toh relationships mein complications create karta hai.",
    "Chandra agar 5th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Mangal agar 6th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Budh agar 7th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Guru agar 8th house mein ho, toh mental peace ko affect karta hai.",
    "Shukra agar 9th house mein ho, toh insaan ko self-confident banata hai.",
    "Shani agar 10th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Rahu agar 11th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Ketu agar 12th house mein ho, toh career mein growth ke chances deta hai.",
    "Surya agar 1st house mein ho, toh emotional ups and downs laa sakta hai.",
    "Chandra agar 2nd house mein ho, toh relationships mein complications create karta hai.",
    "Mangal agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
    "Budh agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Guru agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Shukra agar 6th house mein ho, toh mental peace ko affect karta hai.",
    "Shani agar 7th house mein ho, toh insaan ko self-confident banata hai.",
    "Rahu agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Ketu agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Surya agar 10th house mein ho, toh career mein growth ke chances deta hai.",
    "Chandra agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Mangal agar 12th house mein ho, toh relationships mein complications create karta hai.",
    "Budh agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
    "Guru agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Shukra agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Shani agar 4th house mein ho, toh mental peace ko affect karta hai.",
    "Rahu agar 5th house mein ho, toh insaan ko self-confident banata hai.",
    "Ketu agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Surya agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Chandra agar 8th house mein ho, toh career mein growth ke chances deta hai.",
    "Mangal agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Budh agar 10th house mein ho, toh relationships mein complications create karta hai.",
    "Guru agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Shukra agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Shani agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Rahu agar 2nd house mein ho, toh mental peace ko affect karta hai.",
    "Ketu agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
    "Surya agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Chandra agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Mangal agar 6th house mein ho, toh career mein growth ke chances deta hai.",
    "Budh agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Guru agar 8th house mein ho, toh relationships mein complications create karta hai.",
    "Shukra agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Shani agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Rahu agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Ketu agar 12th house mein ho, toh mental peace ko affect karta hai.",
    "Surya agar 1st house mein ho, toh insaan ko self-confident banata hai.",
    "Chandra agar 2nd house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Mangal agar 3rd house mein ho, toh vyakti mein creativity badhaata hai.",
    "Budh agar 4th house mein ho, toh career mein growth ke chances deta hai.",
    "Guru agar 5th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Shukra agar 6th house mein ho, toh relationships mein complications create karta hai.",
    "Shani agar 7th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Rahu agar 8th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Ketu agar 9th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Surya agar 10th house mein ho, toh mental peace ko affect karta hai.",
    "Chandra agar 11th house mein ho, toh insaan ko self-confident banata hai.",
    "Mangal agar 12th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Budh agar 1st house mein ho, toh vyakti mein creativity badhaata hai.",
    "Guru agar 2nd house mein ho, toh career mein growth ke chances deta hai.",
    "Shukra agar 3rd house mein ho, toh emotional ups and downs laa sakta hai.",
    "Shani agar 4th house mein ho, toh relationships mein complications create karta hai.",
    "Rahu agar 5th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Ketu agar 6th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Surya agar 7th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Chandra agar 8th house mein ho, toh mental peace ko affect karta hai.",
    "Mangal agar 9th house mein ho, toh insaan ko self-confident banata hai.",
    "Budh agar 10th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Guru agar 11th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Shukra agar 12th house mein ho, toh career mein growth ke chances deta hai.",
    "Shani agar 1st house mein ho, toh emotional ups and downs laa sakta hai.",
    "Rahu agar 2nd house mein ho, toh relationships mein complications create karta hai.",
    "Ketu agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
    "Surya agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Chandra agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Mangal agar 6th house mein ho, toh mental peace ko affect karta hai.",
    "Budh agar 7th house mein ho, toh insaan ko self-confident banata hai.",
    "Guru agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Shukra agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Shani agar 10th house mein ho, toh career mein growth ke chances deta hai.",
    "Rahu agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Ketu agar 12th house mein ho, toh relationships mein complications create karta hai.",
    "Surya agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
    "Chandra agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Mangal agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Budh agar 4th house mein ho, toh mental peace ko affect karta hai.",
    "Guru agar 5th house mein ho, toh insaan ko self-confident banata hai.",
    "Shukra agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Shani agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Rahu agar 8th house mein ho, toh career mein growth ke chances deta hai.",
    "Ketu agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Surya agar 10th house mein ho, toh relationships mein complications create karta hai.",
    "Chandra agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Mangal agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Budh agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Guru agar 2nd house mein ho, toh mental peace ko affect karta hai.",
    "Shukra agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
    "Shani agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Rahu agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Ketu agar 6th house mein ho, toh career mein growth ke chances deta hai.",
    "Surya agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Chandra agar 8th house mein ho, toh relationships mein complications create karta hai.",
    "Mangal agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Budh agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Guru agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Shukra agar 12th house mein ho, toh mental peace ko affect karta hai.",
    "Shani agar 1st house mein ho, toh insaan ko self-confident banata hai.",
    "Rahu agar 2nd house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Ketu agar 3rd house mein ho, toh vyakti mein creativity badhaata hai.",
    "Surya agar 4th house mein ho, toh career mein growth ke chances deta hai.",
    "Chandra agar 5th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Mangal agar 6th house mein ho, toh relationships mein complications create karta hai.",
    "Budh agar 7th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Guru agar 8th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Shukra agar 9th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Shani agar 10th house mein ho, toh mental peace ko affect karta hai.",
    "Rahu agar 11th house mein ho, toh insaan ko self-confident banata hai.",
    "Ketu agar 12th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Surya agar 1st house mein ho, toh vyakti mein creativity badhaata hai.",
    "Chandra agar 2nd house mein ho, toh career mein growth ke chances deta hai.",
    "Mangal agar 3rd house mein ho, toh emotional ups and downs laa sakta hai.",
    "Budh agar 4th house mein ho, toh relationships mein complications create karta hai.",
    "Guru agar 5th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Shukra agar 6th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Shani agar 7th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Rahu agar 8th house mein ho, toh mental peace ko affect karta hai.",
    "Ketu agar 9th house mein ho, toh insaan ko self-confident banata hai.",
    "Surya agar 10th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Chandra agar 11th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Mangal agar 12th house mein ho, toh career mein growth ke chances deta hai.",
    "Budh agar 1st house mein ho, toh emotional ups and downs laa sakta hai.",
    "Guru agar 2nd house mein ho, toh relationships mein complications create karta hai.",
    "Shukra agar 3rd house mein ho, toh spiritual inclination ko strong banata hai.",
    "Shani agar 4th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Rahu agar 5th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Ketu agar 6th house mein ho, toh mental peace ko affect karta hai.",
    "Surya agar 7th house mein ho, toh insaan ko self-confident banata hai.",
    "Chandra agar 8th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Mangal agar 9th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Budh agar 10th house mein ho, toh career mein growth ke chances deta hai.",
    "Guru agar 11th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Shukra agar 12th house mein ho, toh relationships mein complications create karta hai.",
    "Shani agar 1st house mein ho, toh spiritual inclination ko strong banata hai.",
    "Rahu agar 2nd house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Ketu agar 3rd house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Surya agar 4th house mein ho, toh mental peace ko affect karta hai.",
    "Chandra agar 5th house mein ho, toh insaan ko self-confident banata hai.",
    "Mangal agar 6th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Budh agar 7th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Guru agar 8th house mein ho, toh career mein growth ke chances deta hai.",
    "Shukra agar 9th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Shani agar 10th house mein ho, toh relationships mein complications create karta hai.",
    "Rahu agar 11th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Ketu agar 12th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Surya agar 1st house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Chandra agar 2nd house mein ho, toh mental peace ko affect karta hai.",
    "Mangal agar 3rd house mein ho, toh insaan ko self-confident banata hai.",
    "Budh agar 4th house mein ho, toh jeevan mein financial stability laa sakta hai.",
    "Guru agar 5th house mein ho, toh vyakti mein creativity badhaata hai.",
    "Shukra agar 6th house mein ho, toh career mein growth ke chances deta hai.",
    "Shani agar 7th house mein ho, toh emotional ups and downs laa sakta hai.",
    "Rahu agar 8th house mein ho, toh relationships mein complications create karta hai.",
    "Ketu agar 9th house mein ho, toh spiritual inclination ko strong banata hai.",
    "Surya agar 10th house mein ho, toh vyakti ko ziddi bana deta hai.",
    "Chandra agar 11th house mein ho, toh apne goal ke liye focused bana deta hai.",
    "Mangal agar 12th house mein ho, toh mental peace ko affect karta hai.",
  ];

const Shimmer = () => {

    const [oneLiner, setOneLiner] = useState('');

    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * oneLiners.length);
        setOneLiner(oneLiners[randomIndex]);
    }, []);

    return (
        <div className='loadin-page'>
            {/* Top Section */}
            <div className="loading-page-container">
              <h3 class="loading-text">{oneLiner}</h3>
              <div className="blur-balls"></div>
              <video className='loading-video' src='https://cdnl.iconscout.com/lottie/premium/thumb/magic-circle-animated-icon-download-in-lottie-json-gif-static-svg-file-formats--occult-magical-sun-mystic-sign-astrology-pack-entertainment-icons-8542368.mp4' autoPlay loop muted></video>
            </div>
        </div>
    );
};

export default Shimmer;
